import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const vrdlogsConfig: TSPConfig = {
  key: 'vrdlogs',
  name: 'VRD Logs',
  imageName: 'VRDLogs',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your VRD Logs profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default vrdlogsConfig;
